/* eslint-disable @typescript-eslint/no-explicit-any */
// import Qs from 'qs'
import service from '@/services/service'

const resource = {
    main: 'services',
    module: 'filters'
}

export class FiltersServices {
    public static getReportCategoriesFilter () {
        return service.get(`${resource.main}/${resource.module}/report-categories`)
    }

    public static getReporDatasourcesFilter () {
        return service.get(`${resource.main}/${resource.module}/report-datasources`)
    }

    public static getReporChartTypesFilter () {
        return service.get(`${resource.main}/${resource.module}/report-chart-types`)
    }

    public static getUsersFilter () {
        return service.get(`${resource.main}/${resource.module}/users`)
    }
}
